import { render, staticRenderFns } from "./Combined.vue?vue&type=template&id=42160f2f&"
import script from "./Combined.vue?vue&type=script&lang=js&"
export * from "./Combined.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports